export const connectionEvents = {
    CONNECTION_FAILED: 'connection-failed'
};
